module.exports = __webpack_public_path__ + "images/柏纳长图_01.jpg?v=e5c946b9";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_01.jpg
 ** module id = 136
 ** module chunks = 1 2
 **/